var map = {
	"./backgrounds/card-link-bg-design.png": "./src/images/backgrounds/card-link-bg-design.png",
	"./backgrounds/card-link-bg-items-old.png": "./src/images/backgrounds/card-link-bg-items-old.png",
	"./backgrounds/card-link-bg-items.png": "./src/images/backgrounds/card-link-bg-items.png",
	"./backgrounds/card-link-bg-signs.png": "./src/images/backgrounds/card-link-bg-signs.png",
	"./characters/arm-questions.svg": "./src/images/characters/arm-questions.svg",
	"./characters/character-card-up.svg": "./src/images/characters/character-card-up.svg",
	"./characters/character-card.svg": "./src/images/characters/character-card.svg",
	"./characters/character-point-left-xs.svg": "./src/images/characters/character-point-left-xs.svg",
	"./characters/character-point-left.svg": "./src/images/characters/character-point-left.svg",
	"./characters/character-smartphone-show.svg": "./src/images/characters/character-smartphone-show.svg",
	"./extras/comment-mentions.svg": "./src/images/extras/comment-mentions.svg",
	"./extras/hand-bottom.svg": "./src/images/extras/hand-bottom.svg",
	"./extras/hand-top.svg": "./src/images/extras/hand-top.svg",
	"./extras/mask-card-number.svg": "./src/images/extras/mask-card-number.svg",
	"./extras/no-ai-mentions.svg": "./src/images/extras/no-ai-mentions.svg",
	"./extras/patch-coming-soon.svg": "./src/images/extras/patch-coming-soon.svg",
	"./extras/waouh.svg": "./src/images/extras/waouh.svg",
	"./extras/watch-flip.svg": "./src/images/extras/watch-flip.svg",
	"./extras/watch.svg": "./src/images/extras/watch.svg",
	"./login-logo.png": "./src/images/login-logo.png",
	"./screenshot.png": "./src/images/screenshot.png",
	"./shapes/bg-banner-produit.svg": "./src/images/shapes/bg-banner-produit.svg",
	"./shapes/bg-footer.svg": "./src/images/shapes/bg-footer.svg",
	"./shapes/bg-ripple-banner.svg": "./src/images/shapes/bg-ripple-banner.svg",
	"./shapes/bg-ripple-card-right-xs.svg": "./src/images/shapes/bg-ripple-card-right-xs.svg",
	"./shapes/bg-ripple-card-right.svg": "./src/images/shapes/bg-ripple-card-right.svg",
	"./shapes/bg-ripple-center.svg": "./src/images/shapes/bg-ripple-center.svg",
	"./shapes/bg-ripple-full.svg": "./src/images/shapes/bg-ripple-full.svg",
	"./shapes/bg-ripple-top-left.svg": "./src/images/shapes/bg-ripple-top-left.svg",
	"./shapes/bg-ripple.svg": "./src/images/shapes/bg-ripple.svg",
	"./shapes/bg-timeline-alt.svg": "./src/images/shapes/bg-timeline-alt.svg",
	"./shapes/bg-timeline.svg": "./src/images/shapes/bg-timeline.svg",
	"./shapes/countdown-bg.svg": "./src/images/shapes/countdown-bg.svg",
	"./shapes/section-top-hills-xs-cropped.svg": "./src/images/shapes/section-top-hills-xs-cropped.svg",
	"./shapes/section-top-hills-xs.svg": "./src/images/shapes/section-top-hills-xs.svg",
	"./shapes/section-top-hills.svg": "./src/images/shapes/section-top-hills.svg",
	"./shapes/stars-dense.svg": "./src/images/shapes/stars-dense.svg",
	"./shapes/stars-lign.svg": "./src/images/shapes/stars-lign.svg",
	"./shapes/stars-sparse.svg": "./src/images/shapes/stars-sparse.svg",
	"./shapes/stars-triangle.svg": "./src/images/shapes/stars-triangle.svg",
	"./shapes/text-circled.svg": "./src/images/shapes/text-circled.svg",
	"./shapes/text-understroke-yellow.svg": "./src/images/shapes/text-understroke-yellow.svg",
	"./shapes/text-understroke.svg": "./src/images/shapes/text-understroke.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync recursive \\.(png%7Csvg%7Cjpg%7Cjpeg%7Cgif)$i";